/**
 * @generated SignedSource<<55a89fe9b66a6975e9a66d933a2848f4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FieldMap$data = {
  readonly geometry: any | null;
  readonly " $fragmentType": "FieldMap";
};
export type FieldMap$key = {
  readonly " $data"?: FieldMap$data;
  readonly " $fragmentSpreads": FragmentRefs<"FieldMap">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FieldMap",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "geometry",
      "storageKey": null
    }
  ],
  "type": "FieldNode",
  "abstractKey": null
};

(node as any).hash = "b0311e6f5b0d3434ddc8ea70242eaad5";

export default node;
